import React from "react";
import LogoSvg from "./LogoSvg";

export default function Logo(props: any) {
  return (
    <>
      <div className="flex ">
        <a
          href={
            process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL && !props.type
              ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/`
              : `${process.env.NEXT_PUBLIC_WEB_URL}` || "/"
          }
          tabIndex={-1}
        >
          <span className="sr-only">Auction Bazaar</span>
          <LogoSvg height={props.height} width={props.width} />
        </a>
      </div>
    </>
  );
}
